export const BASE_URL = {
  dev: 'https://storage.googleapis.com/dev.static.safi.co/static/cms/help-guides/',
  development: '/static/cms/help-guides/',
  production: 'https://storage.googleapis.com/prod.static.safi.co/static/cms/help-guides/',
  sandbox: 'https://storage.googleapis.com/sandbox.static.safi.co/static/cms/help-guides/',
};
